import { useCallback, useEffect } from 'react'

import { CFDLogo } from '@Static/icons/CFDLogo'
import { AnalyticsIcon } from '@Static/icons/HeaderIcon'
import { Link } from 'react-router-dom'

import localStorageManager from '@App/cookies/local_storage_manager'
import { useAppDispatch, useAppSelector } from '@App/hooks'
import { isLogin, logout } from '@App/redux/slices/user/UserSlice'

import { userState } from '@Redux/slices/user/UserSlice'

import { ReportsTabs } from '@UI/crypto_exchange/desktop/pages/spot/components/Reports/model'
import { replaceVarsInPath, ROUTE_NAMES } from '@UI/crypto_exchange/desktop/routes/routeNames'

import { AccountOptionsButton } from './components/AccountOptionsButton'
import { AccountSelect } from './components/AccountSelect'
import { AuthorizationButtons } from './components/AuthorhizationButtons'
import { Balance } from './components/Balance'
import { ThemeSwitcher } from './components/ThemeSwitcher'
import classes from './Header.module.scss'

export const Header = () => {
  const dispatch = useAppDispatch()
  const { theme } = useAppSelector((state) => userState(state))
  const login = useAppSelector((state) => isLogin(state))

  useEffect(() => {
    document.documentElement.dataset.theme = theme === 'dark' ? 'dark' : 'light'
    localStorageManager.set('theme', theme === 'dark' ? 'dark' : 'light')
  }, [theme])

  return (
    <header className={classes.header}>
      <nav className={classes.leftMenu}>
        <Link className={classes.cfdLink} to={ROUTE_NAMES.TRADING}>
          <CFDLogo className={classes.cfdLogo} />
        </Link>
        <ThemeSwitcher />
        {login && (
          <Link className={classes.analyticLink} to={`${replaceVarsInPath(ROUTE_NAMES.REPORTS, [ReportsTabs.Analytics])}`}>
            <AnalyticsIcon width={20} height={20} className={classes.analyticLogo} />
          </Link>
        )}
      </nav>
      <nav className={classes.rightMenu}>
        {login && <Balance />}
        {login && <AccountSelect />}
        {login && <AccountOptionsButton />}
        {!login && <AuthorizationButtons />}
      </nav>
    </header>
  )
}
